var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.559059 17.8817C0.728121 17.9671 0.918574 18.0076 1.11009 17.9988C1.30161 17.99 1.487 17.9323 1.64647 17.8317L14.3524 9.83191C14.4974 9.74059 14.6163 9.61687 14.6985 9.47174C14.7807 9.3266 14.8238 9.16454 14.8238 8.99993C14.8238 8.83532 14.7807 8.67326 14.6985 8.52812C14.6163 8.38299 14.4974 8.25927 14.3524 8.16795L1.64647 0.168146C1.48701 0.0676693 1.30166 0.00996121 1.11019 0.00117782C0.918728 -0.00760557 0.728328 0.0328652 0.559308 0.118273C0.390288 0.20368 0.248989 0.330821 0.150486 0.486129C0.051983 0.641437 -2.86034e-05 0.819087 8.53316e-08 1.00013V16.9997C-7.68606e-05 17.1808 0.0518859 17.3584 0.150345 17.5138C0.248804 17.6691 0.390065 17.7963 0.559059 17.8817ZM2.11765 2.86908L11.8588 8.99993L2.11765 15.1308V2.86908ZM15.8824 14.9998V3.00008C15.8824 2.73487 15.9939 2.48052 16.1925 2.29299C16.391 2.10546 16.6604 2.0001 16.9412 2.0001C17.222 2.0001 17.4913 2.10546 17.6899 2.29299C17.8884 2.48052 18 2.73487 18 3.00008V14.9998C18 15.265 17.8884 15.5193 17.6899 15.7069C17.4913 15.8944 17.222 15.9998 16.9412 15.9998C16.6604 15.9998 16.391 15.8944 16.1925 15.7069C15.9939 15.5193 15.8824 15.265 15.8824 14.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconWhite);
export default __webpack_public_path__ + "static/media/video-icon-white.88c09eb2d634c30b7b4fa701fc05c93e.svg";
export { ForwardRef as ReactComponent };